import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

import SectionTitle from "@components/SectionTitle";

import { InviteOrganizationUserButton } from "@users/organizationuser/components/InviteOrganizationUserButton";

import { useUserContext } from "@hooks/useUserContext";

const QuickActionsPanel: FunctionComponent = () => {
  const { user } = useUserContext();
  const { t } = useTranslation(undefined, {
    keyPrefix: "dashboard.quick-actions"
  });

  return (
    <div className="flex flex-col" data-testid="quickActionsPanel">
      <SectionTitle title={t("section_title")} />
      <div className="flex flex-col gap-10">
        {!user.isAdministrator && (
          <Typography variant="description">No actions</Typography>
        )}
        <InviteOrganizationUserButton />
      </div>
    </div>
  );
};

export default QuickActionsPanel;
